$(document).ready(
    function () {
        $('#ProjectsTasks_worker_id').on(
            'change', function () {
                $('#ProjectsTasks_wallet_number').val('');
                $('.wallet-type').text('');
            }
        );
        
        var changeWalletType = function () {
            if ($('#ProjectsTasks_wallet_number').length &&
                $('#ProjectsTasks_wallet_number').val().substr(0, 1) == 'R') {
                $('.wallet-type').text('WebMoney').css('right', '-64px');
            } else {
                $('.wallet-type').text('Qiwi').css('right', '-22px');
            }
        };
        changeWalletType();
        
        $('#ProjectsTasks_wallet_number').keyup(
            function () {
                changeWalletType();
            }
        );
        
    }
);
